var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.388 1.66L15.5 1l-1.262 3.598a8.037 8.037 0 00-4.784.718 7.676 7.676 0 00-3.127 2.8 6.033 6.033 0 00-.529-.023h-.023a6.008 6.008 0 00-4.077 1.7A5.605 5.605 0 000 13.794c0 1.505.615 2.94 1.698 4.003a6.008 6.008 0 004.077 1.7h3.238L8 22.34l1.888.66 7.5-21.34zM9.715 17.499l3.847-10.97a6.031 6.031 0 00-3.226.583 5.636 5.636 0 00-2.58 2.542l-.346.7-.763-.168a4.029 4.029 0 00-.84-.092c-1.03.025-2 .433-2.708 1.127A3.605 3.605 0 002 13.796c0 .955.39 1.88 1.099 2.575a4.007 4.007 0 002.709 1.128h3.907zm9.72 0h-5.598l-.714 2h5.205v.004l1.002-.002a4.766 4.766 0 003.193-1.227c.87-.79 1.401-1.878 1.47-3.045a4.436 4.436 0 00-1.107-3.19 4.696 4.696 0 00-2.254-1.413 7.403 7.403 0 00-1.897-3.676c-.265-.28-.55-.54-.853-.776l-.723 2.024a5.374 5.374 0 011.586 3.355l.07.819.816.09a2.728 2.728 0 011.752.898c.435.494.65 1.121.613 1.752a2.469 2.469 0 01-.817 1.682 2.761 2.761 0 01-1.744.705z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8808ee35.svg";
export { ForwardRef as ReactComponent };